/** Button registration: the parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseButton } from './parser';
const buttonRegistration = {
    typeName: 'Button',
    parser: parseButton,
};
nodeRegistry.register(buttonRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map